function basePropertyDeep(e){return function(r){return baseGet(r,e)}}var baseGet=require("./_baseGet");module.exports=basePropertyDeep;